import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "card mb-4 border-0 rounded-0" }
const _hoisted_7 = { class: "card-body p-3 p-sm-4 p-md-5 letter-spacing" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "fw-bold fs-0 text-success" }
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = { class: "fw-bold fs-0 text-success formatted-amount" }
const _hoisted_15 = { class: "card mb-4 border-0 rounded-0" }
const _hoisted_16 = { class: "card-body p-3 p-sm-4 p-md-5 letter-spacing" }
const _hoisted_17 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_18 = {
  key: 1,
  class: "accordion dark-accordion",
  id: "produits"
}
const _hoisted_19 = ["id"]
const _hoisted_20 = ["data-bs-target", "aria-controls"]
const _hoisted_21 = { class: "col-md-4 text-start" }
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "col-md-2" }
const _hoisted_24 = { class: "col-md-2 fw-bold" }
const _hoisted_25 = ["id", "aria-labelledby"]
const _hoisted_26 = { class: "accordion-body" }
const _hoisted_27 = { class: "table mt-3" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "badge bg-info" }
const _hoisted_30 = { class: "badge bg-secondary" }
const _hoisted_31 = { class: "fw-medium" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = ["rowspan"]
const _hoisted_34 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Détails de l'approvisionnement", -1)),
            _createVNode(_component_router_link, {
              to: "/approvisionnements/liste-approvisionnements",
              class: "btn btn-primary transition border-0 lh-1 fw-medium text-black"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                _createElementVNode("span", { class: "position-relative" }, "Retour", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "text-black fw-bold mb-3" }, "Informations générales", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Date", -1)),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.format_Date(_ctx.approvisionnement?.dateAppro)), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Nom du Fournisseur", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.approvisionnement?.fournisseur?.nomFournisseur || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Référence", -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.approvisionnement?.refApproGen || 'N/A'), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold" }, "Montant total", -1)),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.format_Montant(_ctx.approvisionnement?.montantTotal)), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[11] || (_cache[11] = _createStaticVNode("<h5 class=\"text-black fw-bold mb-3\" data-v-08f4de96>Produits et magasins</h5><div class=\"row fw-bold border-bottom mb-2 pb-2 text-center\" data-v-08f4de96><div class=\"col-md-4 text-start\" data-v-08f4de96>Nom produit</div><div class=\"col-md-2\" data-v-08f4de96>Quantité</div><div class=\"col-md-2\" data-v-08f4de96>Prix</div><div class=\"col-md-2\" data-v-08f4de96>Montant</div><div class=\"col-md-2\" data-v-08f4de96></div></div>", 2)),
              (!_ctx.approvisionnement?.apropocondis || _ctx.approvisionnement.apropocondis.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[7] || (_cache[7] = [
                    _createElementVNode("p", { class: "text-muted" }, "Aucun produit dans cet approvisionnement", -1)
                  ])))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvisionnement.apropocondis, (produit, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "accordion-item accordion-wrapper",
                        key: index
                      }, [
                        _createElementVNode("h2", {
                          class: "accordion-header",
                          id: `produit${index}`
                        }, [
                          _createElementVNode("button", {
                            class: "accordion-button bg-light font-primary d-flex row w-100 m-0 text-center align-items-center justify-content-between collapsed",
                            type: "button",
                            "data-bs-toggle": "collapse",
                            "data-bs-target": `#collapseProduit${index}`,
                            "aria-expanded": "false",
                            "aria-controls": `collapseProduit${index}`
                          }, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.getProduitNom(produit)), 1),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(produit?.qtite || 0), 1),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.format_Montant(produit?.prixRevient)), 1),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.format_Montant(produit?.montant)), 1),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-2 d-flex justify-content-center align-items-center" }, [
                              _createElementVNode("i", { class: "ms-2 vue-feather vue-feather--chevron-down svg-color" }, [
                                _createElementVNode("svg", {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "20",
                                  height: "20",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                }, [
                                  _createElementVNode("polyline", { points: "6 9 12 15 18 9" })
                                ])
                              ])
                            ], -1))
                          ], 8, _hoisted_20)
                        ], 8, _hoisted_19),
                        _createElementVNode("div", {
                          id: `collapseProduit${index}`,
                          class: "accordion-collapse collapse",
                          "aria-labelledby": `produit${index}`,
                          "data-bs-parent": "#produits"
                        }, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("table", _hoisted_27, [
                              _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", { class: "col-2" }, "Magasin"),
                                  _createElementVNode("th", null, "Quantité"),
                                  _createElementVNode("th", null, "Prix de revient"),
                                  _createElementVNode("th", null, "Montant"),
                                  _createElementVNode("th", null, "Total produit")
                                ])
                              ], -1)),
                              (produit.aprocondimagasins && produit.aprocondimagasins.length > 0)
                                ? (_openBlock(), _createElementBlock("tbody", _hoisted_28, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(produit.aprocondimagasins, (magasin, magIndex) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: magIndex }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", _hoisted_29, _toDisplayString(magasin.magasin?.nomMagasin || 'N/A'), 1)
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("span", _hoisted_30, _toDisplayString(magasin.qteCondAppro || 0), 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.format_Montant(magasin.prixRevient)), 1),
                                        _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.format_Montant(magasin.montantCond)), 1),
                                        (magIndex === 0)
                                          ? (_openBlock(), _createElementBlock("td", {
                                              key: 0,
                                              rowspan: produit.aprocondimagasins.length,
                                              class: "fw-bold text-primary align-middle text-center"
                                            }, _toDisplayString(_ctx.format_Montant(produit?.montant)), 9, _hoisted_33))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("tbody", _hoisted_34, _cache[9] || (_cache[9] = [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", {
                                        colspan: "4",
                                        class: "text-center text-muted"
                                      }, "Aucune distribution en magasin")
                                    ], -1)
                                  ])))
                            ])
                          ])
                        ], 8, _hoisted_25)
                      ]))
                    }), 128))
                  ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}